import React from 'react';
import AppointmentCalendar from './AppointmentCalendar';
import AppointmentTable from './AppointmentTable';

// Calendar by default, list one click away -- the table keeps search, export,
// grouping and inline status editing, none of which the calendar replaces.
export default class AppointmentView extends React.Component {
  state = { view: 'calendar' };

  setView = (view) => this.setState({ view });

  render() {
    const { labels } = this.props;
    const { view } = this.state;

    // One control, rendered inside the calendar's own toolbar so the page has a
    // single row of actions instead of two stacked clusters.
    const viewSwitch = (
      <div className="appointment-view__switch" role="group" aria-label={labels.view_switch}>
        {[
          { key: 'calendar', icon: 'zmdi-view-module', label: labels.calendar_view },
          { key: 'list', icon: 'zmdi-view-headline', label: labels.list_view },
        ].map(option => (
          <button
            key={option.key}
            type="button"
            className={`appointment-view__switch-btn${view === option.key ? ' is-active' : ''}`}
            aria-pressed={view === option.key}
            title={option.label}
            onClick={() => this.setView(option.key)}
          >
            <i className={`zmdi ${option.icon}`} aria-hidden="true" />
            <span className="sr-only">{option.label}</span>
          </button>
        ))}
      </div>
    );

    return (
      <div className="appointment-view">
        {/* Both stay mounted: switching views should not refetch the month or
            throw away the table's search and paging. */}
        <div hidden={view !== 'calendar'}>
          <AppointmentCalendar {...this.props} viewSwitch={viewSwitch} />
        </div>
        <div hidden={view !== 'list'}>
          <div className="appointment-view__list-bar">{viewSwitch}</div>
          <AppointmentTable {...this.props} />
        </div>
      </div>
    );
  }
}
